<template>
  <!-- 充提审核 -->
  <div v-loading="pageLoading" element-loading-text="表格生成中，请稍后...">
    <!-- 顶部选择框 -->
    <div style="margin-bottom: 12px">
      <el-radio-group v-model="form.type" @change="storeage">
        <el-radio-button :label="1">提现审核</el-radio-button>
        <el-radio-button :label="2">充值记录审核</el-radio-button>
      </el-radio-group>
      <el-button type="primary" @click="withdrawalBlacklistBtn" style="margin-left: 10px">提现黑名单</el-button>
      <el-button type="primary" @click="plSuccess">线下转款批量成功</el-button>
      <el-button type="primary" @click="lookNewMoney">现上限金额限制</el-button>
    </div>
    <div class="form">
      <!-- 按时间查询 -->
      <el-date-picker v-model="value" type="daterange" range-separator="至" start-placeholder="提现开始日期"
        end-placeholder="提现结束日期" value-format="yyyy-MM-dd 00:00:00" @change="pickerChange"
        style="width: 306px; margin-right: 10px;">
      </el-date-picker>
      <!-- <el-date-picker v-model="valuePay" type="daterange" range-separator="至" start-placeholder="支付开始日期" end-placeholder="支付结束日期"
        value-format="yyyy-MM-dd 00:00:00" @change="pickerChange" style="width: 304px;margin: 0 10px;">
      </el-date-picker> -->
      <el-select v-model="form.status" placeholder="请输入状态" clearable @clear="Remove" style="width: 200px;">
        <el-option v-for="item in statausList" :key="item.id" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="form">
      <el-input v-model="form.cardNumber" placeholder="请输入卡号" clearable @clear="Remove" style="width: 200px;">
      </el-input>
      <el-input v-model="form.tel" placeholder="请输入电话" clearable @clear="Remove" style="width: 200px; margin-left: 10px">
      </el-input>
      <el-input v-model="form.userId" placeholder="请输入用户Uid" clearable @clear="Remove"
        style="width: 200px; margin-left: 10px">
      </el-input>
      <el-input v-model="form.userName" placeholder="请输入姓名" clearable @clear="Remove"
        style="width: 200px; margin-left: 10px">
      </el-input>
      <el-button type="primary" @click="doFilter" style="margin: 0 10px">搜索</el-button>
      <el-button type="primary" @click="batch" style="margin: 0 5px">批量通过</el-button>
      <el-button type="primary" @click="exportData" style="margin: 0 5px">生成表格</el-button>
      <download-excel v-if="derivedForm" class="export" :data="derivedForm" :fields="jsonFields" type="xls"
        name="充值提现审核表.xls">
        下载表格
      </download-excel>
    </div>
    <!-- <div style="margin-top: 20px; margin-bottom: 40px">
      <el-input v-model="huifubao" placeholder="" clearable disabled style="width: 300px; margin-left: 10px">
        <template #prepend>汇付宝</template>
      </el-input>
      <el-input v-model="lianlianfu" placeholder="" clearable disabled style="width: 300px; margin-left: 10px">
        <template #prepend>连连付</template>
      </el-input>

      <el-input v-model="newlian" placeholder="" clearable disabled style="width: 300px; margin-left: 10px">
        <template #prepend>新连连付</template>
      </el-input>
    </div> -->
    <!-- 提现审核 -->
    <div v-if="form.type == 1">
      <!-- 提现审核表格 -->
      <el-table border :data="formData.tableData" @selection-change="handleSelectionChange"
        :row-class-name="(({ row }) => row.isRed == 2 ? 'el-table_row-red' : '')" ref="tableRefOne">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="记录id" prop="id" width="80" align="center"></el-table-column>
        <el-table-column label="UID" prop="userId" width="120" align="center"></el-table-column>
        <el-table-column label="提现时间" prop="createTime" align="center" width="200"></el-table-column>
        <template v-if="false">
          <el-table-column label="银联号" prop="unionCode" align="center" width="200"></el-table-column>
        </template>
        <el-table-column label="审核时间" prop="updateTime" align="center" width="160"></el-table-column>
        <el-table-column label="绑定的通证" align="center" prop="userTokenName" width="120"></el-table-column>
        <el-table-column label="手机号" align="center" prop="tel" width="120"></el-table-column>
        <el-table-column label="第三方回执单号" align="center" prop="orderSn" width="220"></el-table-column>
        <el-table-column label="到账金额" align="center" prop="actualAmount" width="120"></el-table-column>
        <el-table-column prop="serverChange" align="center" label="手续费" width="100"></el-table-column>
        <!-- <el-table-column prop="" label="账户类型" width="120"></el-table-column> -->
        <el-table-column prop="openBank" label="账户类型" align="center" width="120"></el-table-column>
        <el-table-column prop="subBranch" label="支行信息" width="150"></el-table-column>
        <el-table-column prop="cardNumber" label="账户信息" width="200"></el-table-column>
        <el-table-column prop="userName" label="提现人姓名" width="100"></el-table-column>
        <el-table-column label="状态" width="80">
          <template v-slot="scope">
            <div>
              {{ scope.row.status | statusFilter }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="updateBy" align="center" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.status">
              {{ scope.row.updateBy }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="failedReason" label="失败原因" width="180">
        </el-table-column>
        <!-- <el-table-column prop="sourceAsMap.withdrawReason" label="三方提现失败原因"> </el-table-column>
        <el-table-column prop="sourceAsMap.transferReason" label="三方转出失败原因"> </el-table-column> -->
        <el-table-column fixed="right" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0">
              <el-button type="success" size="mini" @click="handleEdit(scope.row, 1)">通过</el-button>
              <el-button type="danger" size="mini" @click="handleEdit(scope.row, 0)">不通过</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else>
      <el-table border :data="formData.tableData" @selection-change="handleSelectionChange"
        :row-class-name="(({ row }) => row.isRed == 2 ? 'el-table_row-red' : '')" ref="tableRefTwo">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="记录id" prop="id" width="80" align="center"></el-table-column>
        <el-table-column label="UID" prop="userId" width="120" align="center"></el-table-column>
        <el-table-column label="提交时间" prop="createTime" align="center" width="160"></el-table-column>
        <el-table-column label="支付时间" prop="payTime" align="center" width="160"></el-table-column>
        <el-table-column label="审核时间" prop="updateTime" align="center" width="160"></el-table-column>
        <el-table-column label="绑定的通证" align="center" prop="userTokenName" width="120"></el-table-column>
        <el-table-column align="center" prop="amount" label="充值金额" width="120"></el-table-column>
        <el-table-column label="手机号" align="center" prop="tel" width="120"></el-table-column>
        <el-table-column label="到账金额" align="center" prop="actualAmount" width="120"></el-table-column>
        <el-table-column prop="serverChange" align="center" label="手续费" width="100"></el-table-column>
        <!-- <el-table-column prop="" label="账户类型" width="120"></el-table-column> -->
        <el-table-column prop="openBank" label="账户类型" align="center" width="120"></el-table-column>
        <el-table-column prop="subBranch" label="支行信息" width="320"></el-table-column>
        <el-table-column prop="cardNumber" label="账户信息" width="200"></el-table-column>
        <el-table-column label="订单编号" align="center" prop="orderSn" width="300"></el-table-column>
        <el-table-column show-overflow-tooltip label="第三方支付单号" align="center" prop="paySn" width="180"></el-table-column>
        <el-table-column label="支付方式" align="center" width="100">
          <!-- 文付方式，9.汇付快捷支付 10.汇付文付宝支付 11.sand一键快捷 12.sand云账户 13.sand银联支付" -->
          <template slot-scope="{ row }">
            <el-tag type="">{{
              row.payType == "1"
              ? "支付宝"
              : row.payType == "2"
                ? "微信"
                : row.payType == "3"
                  ? "银联"
                  : row.payType == "9"
                    ? "汇付快捷支付"
                    : row.payType == "10"
                      ? "汇付文付宝支付"
                      : row.payType == "11"
                        ? "一键快捷"
                        : row.payType == "12"
                          ? "云账户"
                          : row.payType == "13"
                            ? "银联支付"
                            : row.payType == "16"
                              ? "鲲鹏线下支付"
                              : "线下"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="充值人姓名" width="100"></el-table-column>
        <el-table-column label="状态" width="180">
          <template v-slot="scope">
            <div>
              {{ scope.row.status | statusFilter }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="updateBy" align="center" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.status">
              {{ scope.row.updateBy }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="failedReason" label="失败原因" width="180">
        </el-table-column>
      </el-table>
    </div>
    <!-- 弹出框 -->
    <el-popover placement="center" trigger="click" title="银行信息">
    </el-popover>

    <!-- 底部分页 -->
    <div class="pagination">
      <el-pagination @current-change="handleCurrentChange" background layout="total, prev, pager, next, jumper"
        :total="formData.total">
      </el-pagination>
    </div>
    <!-- 支付方式（汇付宝/连连付） -->
    <el-dialog title="汇款方式" :visible.sync="showselect" width="30%" center :before-close="closeSelect">
      <span>
        <div class="selectbox">
          <div class="contenbox">
            <!-- <el-radio v-model="withdrawType" label="1" border>汇付</el-radio> -->
            <el-radio v-model="withdrawType" label="2" border :disabled="iSyun != 1">云账户</el-radio>
            <el-radio v-model="withdrawType" label="3" border>鲲鹏代付</el-radio>
            <!-- <el-radio v-model="withdrawType" label="3" border>新连连付</el-radio> -->
          </div>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeSelect()">取 消</el-button>
        <el-button type="primary" @click="isTrueEdit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 提现黑名单 -->
    <el-dialog title="提现黑名单" :visible.sync="withdrawalBlacklistDialog" width="30%" center>
      <div>
        <el-form inline>
          <el-form-item>
            <el-input placeholder="请输入手机号" v-model="withdrawalBlackTel"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入UID" v-model="withdrawalBlackUserId"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="() => { withdrawalBlackUserId = ''; withdrawalBlackTel = ''; getWithdrawalBlackList() }">重置</el-button>
            <el-button type="primary" @click="getWithdrawalBlackList">查询</el-button>
            <el-button type="primary" @click="addWithdrawalBlacklist">添加提现黑名单</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="withdrawalBlacklistTableData" style="width: 100%">
          <el-table-column prop="id" label="Id"> </el-table-column>
          <el-table-column prop="userId" label="UID"> </el-table-column>
          <el-table-column prop="tel" label="手机"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template v-slot="scope">
              <el-button type="text" @click="deleteWhite(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px 0 0; display: flex;justify-content: center;">
          <el-pagination @size-change="(e) => { withdrawalBlacklistPageSize = e; getWithdrawalBlackList() }"
            @current-change="(e) => { withdrawalBlacklistCurrentPage = e; getWithdrawalBlackList() }"
            :current-page="withdrawalBlacklistCurrentPage" :page-sizes="[10, 15, 20, 30]"
            :page-size="withdrawalBlacklistPageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="withdrawalBlacklistTotal">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 线下转款批量成功确认 -->
    <el-dialog title="线下转款数据确认" :visible.sync="plSuccessDialog" width="30%" center>
      <div style="padding: 20px;">
        <el-form label-width="100px">
          <el-form-item label="金额：">
            <span style="font-size: 16px; font-weight: bold;">{{ plAmount }}</span>
          </el-form-item>
          <el-form-item label="笔数：">
            <span style="font-size: 16px; font-weight: bold;">{{ plCount }}</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPlSuccess">取 消</el-button>
        <el-button type="primary" @click="confirmPlSuccess">确 认</el-button>
      </span>
    </el-dialog>
    <!-- 现上限金额限制 -->
    <el-dialog title="现上限金额限制" :visible.sync="newMoneyUpPop" width="50%" center>
      <div>
        <el-form inline>
          <!-- <el-form-item>
            <el-input placeholder="请输入手机号" v-model="withdrawalBlackTel"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-input placeholder="请输入UID" v-model="newMoneyUpUserId"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="newMoneyUp">查询</el-button>
            <el-button type="primary" @click="dialogFormVisible = true">添加上限金额</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="newMoneyUpTableData" style="width: 100%">
          <el-table-column prop="id" label="Id"> </el-table-column>
          <el-table-column prop="userId" label="UID"> </el-table-column>
          <el-table-column prop="amount" label="上限金额"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template v-slot="scope">
              <el-button type="text" @click="deleteNewMoeyUp(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px 0 0; display: flex;justify-content: center;">
          <el-pagination @size-change="(e) => { newMoneyUpPageSize = e; newMoneyUp() }"
            @current-change="(e) => { newMoneyUpCurrentPage = e; newMoneyUp() }" :current-page="newMoneyUpCurrentPage"
            :page-sizes="[10, 15, 20, 30]" :page-size="newMoneyUpPageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="newMoneyUpTotal">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="新增上限金额限制" :visible.sync="dialogFormVisible" width="400px">
      <el-form :label-position="'left'" label-width="80px">
        <el-form-item label="UID">
          <el-input v-model="newMoneyForm.userId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="上限金额">
          <el-input v-model="newMoneyForm.amount" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="subMitNewMoneyUp">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { xmlUrl } from "../../utils/xmlurl";
const xlsx = require("xlsx");
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
export default {
  filters: {
    statusFilter(value) {
      switch (value) {
        case 0:
          return "待审核";
        case 1:
          return "审核成功/转款中";
        case 2:
          return "审核失败";
        case 3:
          return "转出成功";
        case 4:
          return "转出失败";
        case 5:
          return "转出异常";
      }
    },
  },
  data() {
    return {
      tabls: "",
      value: "",
      // valuePay: "",
      showselect: false,
      seleceData: "",
      withdrawType: "2",
      form: {
        userId: "",
        bankName: null, // 银行名称
        cardNumber: null, // 卡号
        max: null, // 最大
        min: null, // 最小
        status: null, //0待审核,1成功，2失败
        tel: "", // 电话
        type: 1, //1提现，2充值
        userName: null, // 用户名称
        startTime: "",
        endTime: "",
        // startPayTime: "",
        // endPayTime: "",
        currentPage: 1, // 页码
        pageSize: 10, // 每页条数
      },
      formData: {
        total: 0,
        tableData: [],
      },
      huifubao: "",
      lianlianfu: "",
      newlian: "",
      derivedForm: "", //导出的表格数据
      // 导出表单的格式
      jsonFields: {
        用户ID: "id",
        电话: "tel",
        操作类型: "type",
        提交时间: "createTime",
        审核时间: "updateTime",
        充值提现金额: "amount",
        开户行: "openBank",
        银行卡号: "cardNumber",
        支行名称: "subBranch",
        持卡人姓名: "cardholder",
        状态: "status",
        失败原因: "failedReason",
      },
      statausList: [
        {
          value: 0,
          label: "待审核",
        },
        {
          value: 1,
          label: "审核成功/转款中",
        },
        {
          value: 2,
          label: "审核失败",
        },
        {
          value: 3,
          label: "转出成功",
        },
        {
          value: 4,
          label: "转出失败",
        },
        {
          value: 5,
          label: "转出异常",
        },
      ],
      multipleSelection: [],
      iSyun: "",
      withdrawalBlacklistDialog: false,
      withdrawalBlacklistTableData: [],
      withdrawalBlacklistTotal: 0,
      withdrawalBlacklistPageSize: 10,
      withdrawalBlacklistCurrentPage: 1,
      withdrawalBlackUserId: '',
      withdrawalBlackTel: '',
      kunpengAmout: {
        "forzenAmt": 0,
        "availOutAmt": 0,
      },
      // 线下转款批量成功相关数据
      plSuccessDialog: false,
      plInputDate: '',
      plAmount: 0,
      plCount: 0,
      newMoneyUpPop: false,
      newMoneyUpPageSize: 10,
      newMoneyUpCurrentPage: 1,
      newMoneyUpTableData: [],
      newMoneyUpTotal: 0,
      newMoneyUpUserId: '',
      dialogFormVisible: false,
      newMoneyForm: {
        userId: '',
        amount: ''
      },
      pageLoading: false,
      exportOnlyColumns: [
        { label: '银联号', property: 'unionCode', insertAfter: 'createTime' }
      ]
    };
  },
  mounted() {
    this.getData();
    // 渠道余额
    // this.channelBbalance()
    // 获取所有导出的数据
    // this.exportData();
  },

  methods: {
    // 查看现上限金额限制
    lookNewMoney() {
      this.newMoneyUpPop = true
      this.newMoneyUp()
    },
    newMoneyUp() {
      this.axios
        .get("/admin/userWithdraw/getWithdrawLimit", {
          userId: this.newMoneyUpUserId,
          currentPage: this.newMoneyUpCurrentPage,
          pageSize: this.newMoneyUpPageSize,
        })
        .then((res) => {
          this.newMoneyUpTableData = res.data.data.records;
          this.newMoneyUpTotal = res.data.data.total;
        });
    },
    subMitNewMoneyUp() {
      if (this.newMoneyForm.amount && this.newMoneyForm.userId) {
        this.axios
          .get("/admin/userWithdraw/addWithdrawLimit", this.newMoneyForm)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.mesg)
              this.newMoneyForm.userId = ''
              this.newMoneyForm.userId = ''
              this.dialogFormVisible = false
              this.newMoneyUp()
            } else {
              this.$message.error(res.data.data)
            }
          });
      } else {
        this.$message.error("请完善内容")
      }
    },
    deleteNewMoeyUp(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios
          .get("/admin/userWithdraw/deleteWithdrawLimit", { id: id })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.newMoneyUp()
            } else {
              this.$message.error(res.data.data)
            }
          });
      }).catch(() => {
      });
    },
    // 点击table 获取不同的数据
    storeage(e) {
      this.form.type = e;
      this.form.currentPage = 1;
      this.form.pageSize = 10;
      this.formData.total = 0;

      this.getData();
    },
    /**
     * 选择多个item
     * @param val
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    /**
     * 批量处理
     */
    batch() {
      this.$confirm("此操作将通过所选择提现, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let arr = this.multipleSelection.map((item) => {
            return item.id;
          });
          this.axios
            .post("/admin/userWithdraw/updateBatch", {
              ids: arr,
              status: 1,
            })
            .then((res) => {
              this.$message.success(res.data.mesg);
              this.getData();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 线下转款批量成功
    plSuccess() {
      this.$prompt('请输入日期（例如：2025-11-28）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^\d{4}-\d{2}-\d{2}$/,
        inputErrorMessage: '请输入正确的日期格式（yyyy-MM-dd）'
      }).then(({ value }) => {
        this.plInputDate = value;
        // 调用第一个接口获取金额和笔数
        this.axios
          .get("/admin/userWithdraw/userWithdraw2", {
            date: value
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.plAmount = res.data.data.amount || 0;
              this.plCount = res.data.data.count || 0;
              this.plSuccessDialog = true;
            } else {
              this.$message.error(res.data.mesg || '获取数据失败');
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error('请求失败');
          });
      }).catch(() => {
        // 取消输入
      });
    },
    // 确认线下转款批量成功
    confirmPlSuccess() {
      this.axios
        .get("/admin/userWithdraw/userWithdraw", {
          date: this.plInputDate
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.mesg || '操作成功');
            this.plSuccessDialog = false;
            this.getData();
          } else {
            this.$message.error(res.data.mesg || '操作失败');
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error('请求失败');
        });
    },
    // 取消线下转款批量成功
    cancelPlSuccess() {
      this.plSuccessDialog = false;
    },
    // 从当前页表格实例取出「要导出的列」（去掉多选/序号等）
    getExportColumns(tableRef) {
      const cols = tableRef.store.states.columns || [];
      return cols.filter(
        (c) =>
          c.type !== "selection" &&
          c.type !== "index" &&
          c.type !== "expand" &&
          c.property
      );
    },
    // 表头一行
    getHeaderRow(columns) {
      return columns.map((c) => c.label || "");
    },
    // 按列 property 从行数据取值；若有 formatter 可交给表格同一套逻辑
    rowToArray(row, columns) {
      return columns.map((col) => {
        const key = col.property;
        let val = row[key];
        if (typeof col.formatter === "function") {
          val = col.formatter(row, col, val);
        }
        if (val === null || val === undefined) val = "";
        return val;
      });
    },
    // 拼成 XLSX 要的 aoa：第一行表头，后面是数据行
    buildAoaFromTableAndRows(tableRef, rows) {
      const columns = [...this.getExportColumns(tableRef)];
      this.exportOnlyColumns.forEach((extra) => {
        const idx = columns.findIndex((c) => c.property === extra.insertAfter);
        if (idx !== -1) {
          columns.splice(idx + 1, 0, extra);
        } else {
          columns.push(extra);
        }
      });
      const aoa = [this.getHeaderRow(columns)];
      rows.forEach((row) => {
        aoa.push(this.rowToArray(row, columns));
      });
      return aoa;
    },
    // 获取所有需要导出的数据
    exportData() {
      // this.$message.success("生成中，请稍候");
      // if (!this.form.startTime || !this.form.endTime) {
      //   this.$message.error("请选择时间段进行导出")
      //   return
      // }
      this.pageLoading = true
      const _this = this
      this.axios.get("/admin/userWithdraw/withdrawExcel", this.form).then(() => {
        setTimeout(() => {
          this.axios.get("/admin/userWithdraw/getwithdrawRedis").then((res) => {
            _this.pageLoading = false
            const tableRef = this.$refs[this.form.type == 1 ? 'tableRefOne' : 'tableRefTwo'];
            const arr = res.data.data || [];
            const data = this.buildAoaFromTableAndRows(tableRef, arr);
            // 将数据转换为工作表
            const worksheet = XLSX.utils.aoa_to_sheet(data);
            // 创建工作簿并添加工作表
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            // 生成Excel文件并导出
            const excelBuffer = XLSX.write(workbook, {
              bookType: "xlsx",
              type: "array",
            });
            const dataBlob = new Blob([excelBuffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            });
            saveAs(dataBlob, this.form.type == 1 ? "提现审核.xlsx" : "充值记录审核.xlsx");
          });
        }, 2000);
      });
      // this.$message.success("生成中，请稍候");
      // this.axios
      //   .get("/admin/userWithdraw/withdrawExcel", this.form)
      //   .then((res) => {
      //     console.log(res);
      //     if (res.data.code == 200) {
      //       setTimeout(function () {
      //         window.open(xmlUrl + res.data.data);
      //       }, 5000);
      //     } else {
      //       console("2222");
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
      // 注释这里的原因是后端说这个接口太耗资源，该用列表接口
      // this.axios.get('/admin/userWithdraw/withdrawExcel', {}).then(res => {
      // this.axios.get('/admin/userWater/getTime', {}).then(res => {
      //   if (res.data.code == -1) {
      //     this.axios
      //       .get('/admin/userWithdraw/withdrawExcel', this.form)
      //       .then(res => {
      //         console.log(res)
      //         if (res.data.code == 200) {
      //           window.open(`http://47.109.88.30:9071/${res.data.data}`)
      //         } else {
      //           console('2222')
      //         }
      //       })
      //       .catch(err => {
      //         console.log(err)
      //       })
      //   } else {
      //     this.$message.error('本时段无法生成表格')
      //   }
      // })
    },
    // 获取数据
    getData() {
      this.axios.get("/admin/userWithdraw/findAll", this.form).then((res) => {
        this.formData.total = res.data.data.total;
        this.formData.tableData = res.data.data.records;
      });
    },
    //渠道余额
    channelBbalance() {
      console.log("这是测试");
      this.axios
        .get("/admin/userWithdraw/getMerchantAmount", {})
        .then((res) => {
          console.log("test", res);
          this.huifubao = res.data.data.huifubao;
          this.lianlianfu = res.data.data.lianlianfu;
          this.newlian = res.data.data.lianNew;
        });
    },
    // 通过
    handleEdit(row, store) {
      if (store) {
        this.seleceData = {
          id: row.id,
          status: 1,
        };
        this.axios
          .get("/admin/userWithdraw/findYunAccount", {
            userId: row.userId,
          })
          .then((res) => {
            this.iSyun = res.data.data;
            this.showselect = true;
          });

        return;
        // 通过
        console.log("这是通过");

        this.axios
          .get("/admin/userWithdraw/updateStatus", {
            id,
            status: 1,
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.mesg);
              this.getData();
            } else {
              this.$message.error(res.data.mesg);
            }
          });
      } else {
        // 弹窗  拒绝原因
        this.$prompt("请输入拒绝原因", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /\S/,
          inputErrorMessage: "请输入拒绝的原因",
        })
          .then(({ value }) => {
            this.axios
              .get("/admin/userWithdraw/updateStatus", {
                failedReason: value,
                id: row.id,
                status: 2,
              })
              .then((res) => {
                if (res.data.code == 200) {
                  this.$message.success(res.data.mesg);
                  this.getData();
                } else {
                  this.$message.error(res.data.mesg);
                }
              });
          })
          .catch((err) => { });
      }
    },
    // 通过审核
    isTrueEdit() {
      this.seleceData["withdrawType"] = this.withdrawType;
      this.axios
        .get("/admin/userWithdraw/updateStatus", this.seleceData)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.mesg);
            this.seleceData = "";
            this.showselect = false;
            this.withdrawType = "";
            this.getData();
          } else {
            if (res.data.code == -1) {
              this.$message.error(res.data.data);
            } else {
              this.$message.error(res.data.mesg);
            }
          }
        });
      console.log(this.seleceData);
    },
    // 取消选择汇款方式
    closeSelect() {
      this.seleceData = "";
      this.showselect = false;
      this.withdrawType = "";
    },
    //   搜索
    doFilter() {
      this.form.currentPage = 1;
      this.getData();
    },

    Remove() {
      this.form.currentPage = 1;
      this.getData();
    },

    handleCurrentChange(val) {
      this.form.currentPage = val;
      this.getData();
    },

    // 提现时间
    pickerChange(e) {
      if (e) {
        this.form.startTime = e[0];
        this.form.endTime = e[1];
      } else {
        delete this.form.startTime;
        delete this.form.endTime;
      }
      this.form.currentPage = 1;
      this.getData();
    },
    // 支付时间
    // pickerChange(e) {
    //   if (e) {
    //     this.form.startPayTime = e[0];
    //     this.form.endPayTime = e[1];
    //   } else {
    //     delete this.form.startPayTime;
    //     delete this.form.endPayTime;
    //   }
    //   this.form.currentPage = 1;
    //   this.getData();
    // },
    // 提现黑名单
    withdrawalBlacklistBtn() {
      this.withdrawalBlacklistDialog = true;
      this.getWithdrawalBlackList()
    },
    getWithdrawalBlackList() {
      this.axios
        .get("/admin/userWithdraw/getWhiteList", {
          currentPage: this.withdrawalBlacklistCurrentPage,
          pageSize: this.withdrawalBlacklistPageSize,
          userId: this.withdrawalBlackUserId,
          tel: this.withdrawalBlackTel
        })
        .then((res) => {
          console.log(res);
          this.withdrawalBlacklistTableData = res.data.data.records;
          this.withdrawalBlacklistTotal = res.data.data.total;
        });
    },
    // 添加黑名单
    addWithdrawalBlacklist() {
      this.$prompt("请输入提现黑名单账户", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        this.axios
          .get("/admin/userWithdraw/addWhite", {
            tel: value,
          })
          .then((res) => {
            if (res.data.code != 200) {
              this.$message({
                type: "error",
                message: res.data.data,
              });
            } else {
              this.getWithdrawalBlackList();
              this.$message({
                type: "success",
                message: "添加成功",
              });
            }
          });
      });
    },
    // 提现黑名单删除
    deleteWhite(id) {
      this.axios
        .get("/admin/userWithdraw/deleteWhite", {
          id: id,
        })
        .then((res) => {
          this.getWithdrawalBlackList();
          this.$message({
            type: "success",
            message: "删除成功",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  margin-bottom: 12px;
}

.pagination {
  text-align: center;
  margin: 20px auto 0;
}

// 导出样式
.export {
  color: #fff;
  background-color: #409eff;
  width: 90px;
  min-width: 90px;
  height: 40px;
  border-radius: 5px;
  text-align: center;
  line-height: 40px;
  font-size: 12px;
}

.export:hover {
  cursor: pointer;
}

.selectbox {
  width: 100%;
  // height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 1px solid red;
  // .contenbox {
  //   border: 1px solid red;
  // }
}
</style>

<style>
.el-table .el-table_row-red {
  background: rgba(250, 181.5, 181.5, 1) !important;
}

.el-table .el-table_row-red.hover-row .el-table__cell {
  background: rgba(250, 181.5, 181.5, 1) !important;
}
</style>